var withCappedText = function withCappedText(_ref) {
  var _ref$defaultFontSize = _ref.defaultFontSize,
      defaultFontSize = _ref$defaultFontSize === void 0 ? 'md' : _ref$defaultFontSize,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      fontMetrics = _ref.fontMetrics;
  return {
    cappedText: {
      fontMetrics: fontMetrics,
      htmlFontSize: htmlFontSize
    },
    components: {
      Text: {
        defaultProps: {
          fontSize: defaultFontSize
        }
      },
      Heading: {
        defaultProps: {
          fontSize: defaultFontSize
        }
      }
    }
  };
};

export { withCappedText };
